/* eslint no-debugger: "off" */

import axios from "axios";
import store from "@/store";
import router from "@/router";
import { Modal } from "ant-design-vue";
import { getStorage, setStorage, clearStorage } from "@/utils/index";
import { loginOut } from "@/views/Home/components/HeaderOperation/components/configs/config";
import { signOut } from "@/api/user.js";
import { getBpmToken } from "@/api/back.js";
import { routerPath } from "./routerPath";
let timeoutModalTrigger = false; // 弹窗的显示开关

// 检查接口是否是知产数仓的api
// const checkIsDatabaseApi = function(url) {
//   return /^\/database/.test(url)
// }
// 根据api不同设置不同的token
let bpmUrl = [];
const settingToken = function (config) {
  const visitor = getStorage("visitor", 0); //游客
  const token = getStorage("token", 0); //后台管理||华师
  const bpmToken = getStorage("bpmToken", 0); //图谱，一体化等跳转token
  const hasPath = routerPath.some((item) => config.url.includes(item));
  if (hasPath) {
    console.log("hasPath", hasPath);
    //config.url = config.url.replace("api", "bpm");
    if (!bpmUrl.includes(config.url)) {
      bpmUrl.push(config.url);
    }
    config.headers.Authorization = `Bearer ${bpmToken}`;
  } else {
    config.headers.Authorization = token
      ? `Bearer ${token}`
      : `Bearer ${visitor}`;
  }
};
let isRefreshToken = false; // 是否已经发出刷新请求
const requestList = []; // token过期的api列表
const baseURL = process.env.VUE_APP_BASE_URL;
let overTimer = 0; // 溢出次数
// const baseURL = 'https://sfio.ipsunlight.com/api'

// create an axios instance
const service = axios.create({
  headers: {
    "content-type": "application/json;charset=UTF-8",
  },
  baseURL, // api的base_url
  timeout: 65 * 1000, // request timeout
  withCredentials: true,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    settingToken(config);
    if (config.url.indexOf("tenantManage") !== -1) {
      delete config.headers.Authorization;
    }
    // 如果是请求auth接口，则不带token
    if (
      config.url.indexOf("/auth?") !== -1 ||
      config.url.indexOf("/getTenantByCode?") !== -1
    ) {
      delete config.headers.Authorization;
    }
    if (config.url.indexOf("/refresh/token") !== -1) {
      // 刷新token的接口不带 authorization请求头
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = [];
// response 拦截器
// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中

service.setToken = (token) => {
  service.defaults.headers.Authorization = `Bearer ${token}`;
  setStorage("visitor", token, 0);
};

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const { code } = response.data;
    console.log("code", code);
    //const visitor = getStorage("visitor", 0);
    if (code === 401) {
      // 认证失效跳登录
      // setStorage('token', '', 0)
      // router.push({name:'Login'})
      if (getStorage("token", 0)) {
        if (!bpmUrl.includes(response.config.url)) {
          tipsAccountTimeout(); // 长时间未操作弹窗提示
        }
      } else {
        const { config } = response;
        if (!isRefreshing) {
          isRefreshing = true;
          let form = {
            username: "visitor@qq.com",
            password: "123456",
          };
          store
            .dispatch("user/LoginForm", form)
            .then((res) => {
              console.log("res", res);
              const { token } = res;
              service.setToken(token);
              config.headers.Authorization = `Bearer ${token}`;
              config.baseURL = baseURL;
              // 已经刷新了token，将所有队列中的请求进行重试
              requests.forEach((cb) => cb(token));
              requests = [];
              return service(config);
            })
            .catch((error) => {
              console.error("refreshtoken error =>", error);
            })
            .finally(() => {
              isRefreshing = false;
            });
        }
        // 正在刷新token，将返回一个未执行resolve的promise
        return new Promise((resolve) => {
          // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
          requests.push((token) => {
            config.baseURL = baseURL;
            config.headers.Authorization = token;
            resolve(service(config));
          });
        });
      }
      //  else {
      //   window.location.reload();
      // }
    } else {
      if (response.config.url.indexOf("/refresh/token") === -1) {
        // 只要其中一个不是刷新token得请求，得到正常响应，就重置次数限制
        overTimer = 0;
      }
      return response.data;
    }
  },
  (error) => {
    if (error.response && error.response.status) {
      const { status, config } = error.response;
      //const msg = `${status}:${statusText}`;
      //console.log(config);
      if (status === 401 && overTimer < 2) {
        if (getBpmToken("bpmToken", 0)) {
          if (!isRefreshing) {
            isRefreshing = true;
            getBpmToken()
              .then((res) => {
                const { token } = res;
                service.defaults.headers.Authorization = `Bearer ${token}`;
                setStorage("bpmToken", token, 0);
                config.headers.Authorization = `Bearer ${token}`;
                config.baseURL = baseURL.replace("/api", "");
                // 已经刷新了token，将所有队列中的请求进行重试
                requests.forEach((cb) => cb(token));
                requests = [];
                return service(config);
              })
              .catch((error) => {
                console.error("refreshtoken error =>", error);
              })
              .finally(() => {
                isRefreshing = false;
              });
          }
          // 正在刷新token，将返回一个未执行resolve的promise
          return new Promise((resolve) => {
            // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
            requests.push((token) => {
              config.baseURL = baseURL.replace("/api", "");
              config.headers.Authorization = token;
              resolve(service(config));
            });
          });
        }
        if (!getStorage("token", 0)) {
          return refreshDatabaseBinToken(config);
        }
      } else {
        //message.error(msg, 0.8);
      }
    }
    return Promise.reject(error);
  }
);

const jump = async () => {
  await signOut();
  if (getStorage("huashi", 0)) {
    clear();
    window.location.href = `${loginOut}`;
  } else {
    clear();
    router.push("/login");
  }
};

function clear() {
  store.dispatch("user/clearAccountInfo");
  clearStorage();
}

// 401 弹窗提示
const tipsAccountTimeout = function () {
  if (timeoutModalTrigger) return;
  timeoutModalTrigger = true;
  Modal.warning({
    onCancel: function () {
      jump();
      timeoutModalTrigger = false;
    },
    onOk: function () {
      jump();
      timeoutModalTrigger = false;
    },
    footer: null,
    title: "系统提示",
    content: "因长时间未操作，或因其他用户登录此账号而被登出，请重新登录",
    maskClosable: true,
  });
};

// 知产数仓的无感知刷新逻辑
const refreshDatabaseBinToken = async function (config) {
  if (!isRefreshToken) {
    isRefreshToken = true; // token已经重新请求了
    await store.dispatch("bigScreen/getDatabaseBinToken"); // 请求和设置结果
    while (requestList.length > 0) {
      requestList.shift()(); // 按顺序执行回调
    }
    overTimer++;
    isRefreshToken = false;
    return service(config);
  } else {
    return new Promise((resolve) => {
      requestList.push(() => {
        settingToken(config); // 给config加上token
        resolve(service(config));
      });
    });
  }
};

export default service;
